import KeenSlider from 'keen-slider';
if (!customElements.get('ia-slideshow')) {

  class IASlideshow extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.currentSlideElement = null;
      this.prevButton = null;
      this.nextButton = null;
      this.autoplay = this.getAttribute('data-autoplay') === 'true';
      const intervalAttr = this.getAttribute('data-autoplay-interval');
      this.autoplayInterval = intervalAttr ? parseInt(intervalAttr, 10) : 6000;
      if (isNaN(this.autoplayInterval) || this.autoplayInterval <= 0) {
        this.autoplayInterval = 6000;
      }
      this.autoplayTimer = null;
      this.centeredMobile = this.getAttribute('data-centered-mobile') === 'true';
      this.centeredDesktop = this.getAttribute('data-centered-desktop') === 'true';
    }
  
    connectedCallback() {
      this.initializeSlideshow();
    }
  
    disconnectedCallback() {
      this.stopAutoplay();
      if (this.slider) {
        this.slider.destroy();
      }
    }
  
    initializeSlideshow() {
      const carousel = this.querySelector('.ia-slideshow__carousel');
      this.currentSlideElement = this.querySelector('.js-ia-slideshow-current');
      this.prevButton = this.querySelector('.js-ia-slideshow-prev');
      this.nextButton = this.querySelector('.js-ia-slideshow-next');
  
      if (!carousel) {
        return;
      }
      const self = this;
      const sliderInstance = new KeenSlider(carousel, {
        loop: true,
        duration: 1000,
        initial: this.centeredDesktop ? 1 : 0,
        drag: this.centeredDesktop ? false : true,
        slides: {
          origin: this.centeredDesktop ? "center" : undefined,
          perView: this.dataset.perViewDesktop || 1,
          spacing: this.dataset.spacingDesktop || 0,
        },
        breakpoints: {
          '(max-width: 1023px)': {
            initial: this.centeredMobile ? 1 : 0,
            drag: true,
            slides: {
              perView: this.dataset.perViewMobile || 1,
              spacing: this.dataset.spacingMobile || 0,
              origin: this.centeredMobile ? 0.25 : undefined,
            },
          },
        },
        created: (slider) => {
          // Start autoplay after a short delay to ensure slider is ready
          if (self.autoplay) {
            setTimeout(() => {
              self.startAutoplay();
            }, 1000);
          }
        }
      });
      
      // Store slider reference
      this.slider = sliderInstance;
  
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => {
          this.slider.prev();
        });
      }
  
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => {
          this.slider.next();
        });
      }
  
      sliderInstance.on('slideChanged', (slide) => {
        if (sliderInstance?.track?.details?.rel >= 0 && this.currentSlideElement) {
          this.currentSlideElement.textContent = sliderInstance.track.details.rel + 1;
        }
      });

      // Pause autoplay on hover
      if (this.autoplay) {
        this.addEventListener('mouseenter', () => {
          this.stopAutoplay();
        });
        this.addEventListener('mouseleave', () => {
          this.startAutoplay();
        });
      }
    }

    startAutoplay() {
      this.stopAutoplay();
      if (this.slider && this.autoplay) {
        this.autoplayTimer = setInterval(() => {
          if (this.slider) {
            this.slider.next();
          }
        }, this.autoplayInterval);
      }
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }
  
    next() {
      if (this.slider) {
        this.slider.next();
      }
    }
  
    prev() {
      if (this.slider) {
        this.slider.prev();
      }
    }
  
    goToSlide(index) {
      if (this.slider) {
        this.slider.moveToIdx(index);
      }
    }
  
    destroy() {
      if (this.slider) {
        this.slider.destroy();
        this.slider = null;
      }
    }
  }
  
  
  customElements.define('ia-slideshow', IASlideshow); 
}